import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class MarketplaceService {
  cart: Array<any>;
  prescriptionList: Array<any>;
  prescription: any;
  customer: any;
  prescriptionUploadInProgress: boolean;
  private apiOrigin = environment.apiOrigin;

  constructor(private http: HttpClient) {
    this.cart = [];
    this.prescriptionList = [];
  }

  getProductsInHand(searchText: string, plantCode: string, isWalkIn: boolean): Observable<any> {
    if (isWalkIn) {
      const url = `${environment.apiOrigin}/CatalogService/api/products/inventory/${searchText}/${plantCode}`;
      return this.http.get(url);
    } else {
      const url = `${environment.apiOrigin}/CatalogService/api/products/inventory/${searchText}/all`;
      return this.http.get(url);
    }
  }
  public getProducts(): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/products`;

    return this.http.get(url);
  }

  public getYetToDispatchOrders(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetYetToDispatchOrders`;

    return this.http.get(url);
  }

  public getYetToBeVerifiedOrders(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetYetToBeVerifiedOrders`;

    return this.http.get(url);
  }

  public getYetToBePackagedOrders(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetYetToBePackagedOrders`;

    return this.http.get(url);
  }

  public getYetToBeDispatchedOrders(): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/orders/pending`;

    return this.http.get(url);
  }

  public getAllOrders(): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/protected/orders`;

    return this.http.get(url);
  }

  public getLogisticsCompanies(): Observable<any> {
    const url = `${this.apiOrigin}/OrderService/api/logistics-providers`;

    return this.http.get(url);
  }

  public generateOrder(orderId: string): Observable<any> {
    //const url = `${environment.apiOrigin}/OrderService/api/order/generate/${orderId}`;
    /*const url = `http://localhost:5000/api/order/generate/${orderId}`;*/
    const url = `${environment.apiOrigin}/marketplace/order/generateinvoice/${orderId}`;

    return this.http.post(url, {});
  }

  public getCashOrders(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetCashOrders`;
    let params = new HttpParams();
    var date = new Date();
    params = params.append('date', date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate().toString());

    return this.http.get(url, { params: params });
  }

  public generateBill(orderNumber: string): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/bill/generate/${orderNumber}`;

    return this.http.post(url, {});
  }

  public fetchStoreInfo(orderId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/FetchStoreInfo`;
    let params = new HttpParams();
    params = params.append('orderId', orderId);

    return this.http.get(url, { params: params });
  }

  public getSellers(): Observable<any> {
    const url = `${this.apiOrigin}/api/marketplace/sellers`;

    return this.http.get(url);
  }

  public getDocument(documentId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetDocument`;

    return this.http.get(url, {
      params: new HttpParams().set('documentId', documentId)
    });
  }

  public deleteDocument(fileId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteDocument`;

    return this.http.delete(url, {
      params: new HttpParams().set('fileId', fileId)
    });
  }

  public updatePrescriptions(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/UpdatePrescriptions`;

    return this.http.post(url, this.customer);
  }

  public processOfflineOrder(customer: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/ProcessOfflineOrder`;

    return this.http.post(url, customer);
  }


  public processOrder(customerId: string, cartOrder: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/save/${customerId}`;

    return this.http.put(url, cartOrder);
  }

  public getOrder(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/order/${orderId}`;

    return this.http.get(url);
  }

  public refreshBatchInformationForAllProducts(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/FetchAndSaveBatchInformationForAllProducts`;

    return this.http.get(url);
  }

  public validateOrder(orderValidationView: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/validate`;

    return this.http.post(url, orderValidationView);
  }

  public packageOrder(dispatchInfo: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/package`;
    return this.http.post(url, dispatchInfo);
  }

  public dispatchOrder(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/dispatch/${orderId}`;
    return this.http.post(url, {});
  }

  public updateOrderInfo(order: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/order/update`;
    return this.http.post(url, order);
  }

  public uploadDocuments(userId: string, patientName: string, files: File[], customer: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/UploadDocuments`;

    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }
    formData.append('userId', userId);
    formData.append('patientName', patientName);

    return this.http.post(url, formData);
  }

  public uploadFiles(userId: string, fileType: string, files: File[]): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/UploadFiles`;

    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }
    formData.append('userId', userId);
    formData.append('fileType', fileType);

    return this.http.post(url, formData);
  }

  public getSellerList(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetSellerList`;

    return this.http.get(url);
  }

  public getProductSellers(productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetProductSellers`;

    return this.http.get(url, {
      params: new HttpParams().set('productSlug', productSlug)
    });
  }

  public getProductApps(productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetProductApps`;

    return this.http.get(url, {
      params: new HttpParams().set('productSlug', productSlug)
    });
  }

  public getProductSkuComponents(productSlug: string, skuCode: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetProductSkuComponents`;

    let params = new HttpParams();
    params = params.append('productSlug', productSlug);
    params = params.append('skuCode', skuCode);

    return this.http.get(url, { params: params });
  }

  public getProductSkus(productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetProductSkus`;

    let params = new HttpParams();
    params = params.append('productSlug', productSlug);

    return this.http.get(url, { params: params });
  }

  public getActiveUnApprovedPromotions(searchText: string, fromDiscount: number, toDiscount: number): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/unapproved`;
    let fd: string = fromDiscount == 0 ? '' : fromDiscount.toString();
    let td: string = toDiscount == 0 ? '' : toDiscount.toString();

    if (!searchText) {
      searchText = '';
    }

    let params = new HttpParams();
    params = params.append('searchText', searchText);
    params = params.append('fromDiscount', fd);
    params = params.append('toDiscount', td);

    return this.http.get(url, { params: params });
  }

  public savePromotionStatus(selectedPromos: any, approved: boolean): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/update/status`;

    let promotions: any = new Object();
    promotions.selectedPromos = selectedPromos;
    promotions.approved = approved;

    return this.http.post(url, promotions);
  }

  public updateCart(user: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/UpdateCart`;

    return this.http.post(url, user);
  }

  public updateDeliveryAddress(customer: any, address: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/UpdateDeliveryAddress`;

    customer.cartOrder.deliveryAddress = address;

    return this.http.post(url, customer);
  }

  public saveDeliveryAddress(customerId: any, address: any): Observable<any> {
    const url = `${environment.apiOrigin}/UserService/api/user/cart/address`;

    return this.http.post(url, address, {
      params: new HttpParams().set("userId", customerId)
    });
  }

  public getSellerInfo(sellerId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetSellerInfo`;

    return this.http.get(url, {
      params: new HttpParams().set('sellerId', sellerId)
    });
  }

  public savePromoCode(item: any): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/save`;

    return this.http.put(url, item);
  }

  public getCatalogProductSkusPricing(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetCatalogProductSkusPricing`;

    return this.http.get(url);
  }

  public getPendingPrescriptions(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/GetPendingPrescriptions`;

    return this.http.get(url);
  }


  public getActivePromotions(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetActivePromotions`;

    return this.http.get(url);
  }

  public getCustomerActivePromotions(customerId: string): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/customer/${customerId}`;

    return this.http.get(url);
  }

  public getUnApprovedOrRejectedPromotions(customerId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetUnApprovedOrRejectedPromotions`;

    return this.http.get(url, {
      params: new HttpParams().set('customerId', customerId)
    });
  }

  public moveToBacklog(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/TransferValidatedOrdersToBacklog`;

    return this.http.get(url);
  }

  public getProductInfo(productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetProductInfo`;


    return this.http.get(url, {
      params: new HttpParams().set('productSlug', productSlug)
    });
  }

  public deleteSkuForProduct(skuCode: string, productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteSkuForProduct`;
    let params = new HttpParams();
    params = params.append('skuCode', skuCode);
    params = params.append('productSlug', productSlug);

    return this.http.get(url, { params: params });
  }

  public deleteComponentForProductSku(componentName: string, productSlug: string, skuCode: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteComponentForProductSku`;
    let params = new HttpParams();
    params = params.append('componentName', componentName);
    params = params.append('productSlug', productSlug);
    params = params.append('skuCode', skuCode);

    return this.http.get(url, { params: params });
  }

  public deleteSellerForProduct(sellerName: string, productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteSellerForProduct`;

    let params = new HttpParams();
    params = params.append('sellerName', sellerName);
    params = params.append('userId', productSlug);

    return this.http.get(url, { params: params });
  }

  public deleteAppForProduct(appName: string, productSlug: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteAppForProduct`;

    let params = new HttpParams();
    params = params.append('appName', appName);
    params = params.append('productSlug', productSlug);

    return this.http.get(url, { params: params });
  }

  public saveSeller(seller: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveSeller`;

    return this.http.post(url, seller);
  }

  public deleteSeller(sellerId: string): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteSeller`;

    return this.http.get(url, {
      params: new HttpParams().set('sellerId', sellerId)
    });
  }

  public saveSellerForProduct(seller: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveSellerForProduct`;

    return this.http.post(url, seller);
  }

  getCustomerSetupPricing(contactId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/get-special-pricing?contactId=${contactId}`;
    return this.http.get(url);
  }

  public saveAppForProduct(appInfo: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveAppForProduct`;

    return this.http.post(url, appInfo);
  }

  public saveSkuForProduct(sku: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveSkuForProduct`;

    return this.http.post(url, sku);
  }

  public saveComponentForProductSku(component: any): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveComponentForProductSku`;

    return this.http.post(url, component);
  }

  getSellerStores(sellerId: string) {
    const url = `${this.apiOrigin}/Marketplace/v1/GetSellerStores`;

    return this.http.get(url, {
      params: new HttpParams().set('sellerId', sellerId)
    });
  }

  getSellerBusinessUnits(sellerId: string) {
    const url = `${this.apiOrigin}/Marketplace/v1/GetSellerBusinessUnits`;

    return this.http.get(url, {
      params: new HttpParams().set('sellerId', sellerId)
    });
  }

  deleteStoreForSeller(storeLocation: string, sellerId: string) {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteStoreForSeller`;
    let params = new HttpParams();
    params = params.append('storeLocation', storeLocation);
    params = params.append('sellerId', sellerId);

    return this.http.get(url, { params: params });
  }

  deleteBusinessUnitForSeller(businessUnitName: string, sellerId: string) {
    const url = `${this.apiOrigin}/Marketplace/v1/DeleteBusinessUnitForSeller`;
    let params = new HttpParams();
    params = params.append('businessUnitLocation', businessUnitName);
    params = params.append('sellerId', sellerId);

    return this.http.get(url, { params: params });
  }

  saveStoreForSeller(store: any) {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveStoreForSeller`;

    return this.http.post(url, store);
  }

  saveBusinessUnitForSeller(businessUnit: any) {
    const url = `${this.apiOrigin}/Marketplace/v1/SaveBusinessUnitForSeller`;

    return this.http.post(url, businessUnit);
  }

  getUnApprovedPromoCodes(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetUnApprovedPromoCodes`;


    return this.http.get(url);
  }

  getUnApprovedPromoStatistics(): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/statistics`;


    return this.http.get(url);
  }

  approvePromoCode(promoCodeId: string, isApproved: boolean): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/ApprovePromoCode`;
    let params = new HttpParams();
    params = params.append('promoCodeId', promoCodeId);
    params = params.append('isApproved', isApproved.toString());

    return this.http.get(url, { params: params });
  }

  getStoreStatistics(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/v1/GetStoreStatistics`;

    return this.http.get(url);
  }

  getPendingTranscriptionsCount(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/GetPendingTranscriptionsCount`;

    return this.fetch(url);
  }

  getOrdersCountWithMissingDocuments(): Observable<any> {
    const url = `${this.apiOrigin}/Marketplace/GetOrdersCountWithMissingDocuments`;

    return this.fetch(url);
  }

  public fetch(url: string, params: any = null): Observable<any> {

    if (params != null) {
      return this.http.get(url, { params: params });
    } else {
      return this.http.get(url);
    }
  }

  deleteOrder(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/order/${orderId}`;
    return this.http.delete(url);
  }

  getOrderDocuments(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/documents/${orderId}`;
    return this.http.get(url);
  }

  fetchAttachments(orderId: string, userId: string): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/attachments`;

    let params = new HttpParams();
    params = params.append('orderId', orderId);
    params = params.append('userId', userId);

    return this.http.get(url, { params: params });
  }

  cancelOrder(orderNumber: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/cancel/${orderNumber}`;
    return this.http.post(url, {});
  }

  changeOrderLocation(id: string, storeLocation: string): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order/update/location/${id}/${storeLocation}`;
    return this.http.post(url, {});
  }
  getPreApprovedPricingList(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/pre-approved-special-pricing-list`;
    return this.http.get(url);
  }
  saveCustomerPricing(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/customer-approved-pricing-from-order-history/${contactId}`;
    return this.http.post(url, {});
  }

  getCustomerApprovedPricing(contactId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/customer-approved-pricing/${contactId}`;
    return this.http.get(url);
  }
  getMyStoreLocations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/my-store-locations`;
    return this.http.get(url);
  }
  getStockistStateCity(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/get-state-wise-stockist-city`;
    return this.http.get(url);
  }
  searchProductsInStore(searchText: string, storeCode: string = null): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-products-in-store`;
    const criteria: any = {};
    criteria.searchText = searchText;
    criteria.storeCode = storeCode;
    return this.http.post(url, criteria);
  }


  searchProductsInStoreQunatityWise(searchText: string, storeCode: string = null): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-products-in-store-quantity-wise`;
    const criteria: any = {};
    criteria.searchText = searchText;
    criteria.storeCode = storeCode;
    return this.http.post(url, criteria);
  }
  updateInventory(productSkuCode: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/update-inventory/${productSkuCode}`;
    return this.http.get(url);
  }
  saveCustomerOrder(order: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/customer-order`;
    return this.http.put(url, order);
  }

  updatePreApprovedPricingList(preApprovedItem: any): Observable<any> {

    const url = `${environment.apiOrigin}/api/marketplace/update-pre-approved-special-pricing`;
    return this.http.patch(url, preApprovedItem);

  }
  deletePreApprovedPricingList(id: any): Observable<any> {

    const url = `${environment.apiOrigin}/api/marketplace/delete-pre-approved-special-pricing?Id=${id}`;
    return this.http.delete(url);

  }
  savePreApprovedPricing(preApprovedItem: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/pre-approved-special-pricing`;
    return this.http.post(url, preApprovedItem);
  }

  saveCustomerApprovedPricing(approvedItem: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/approved-customer-special-pricing`;
    return this.http.post(url, approvedItem);
  }
  deleteSpecialRate(id): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/customer-approved-pricing/${id}`;
    return this.http.delete(url);
  }
  // this.order.id
  public generateCustomerOrder(orderId: string, invoiceNo: any): Observable<any> {
    // const url = `${environment.apiOrigin}/api/marketplace/customer-order/${orderId}`;
    const url = `${environment.apiOrigin}/api/marketplace/order/generateinvoice/${orderId}/${invoiceNo}`;
    return this.http.post(url, {});
  }
  public Updateinvoiceorder(orderId: string, invoiceNo: string): Observable<any> {
    //const url = `${environment.apiOrigin}/api/marketplace/customer-order/${orderId}`;
    const url = `${environment.apiOrigin}/api/marketplace/order/updateinvoice/${orderId}/${invoiceNo}`;
    return this.http.patch(url, {});
  }
  public deleteinovoiceOrder(orderId: string, Remarks: string, Reason: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/delete-order`;
    return this.http.put(url, { orderId, Remarks, Reason });
  }
  public returnorder(ReturnBatchInventory: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/return-order`;
    return this.http.put(url, ReturnBatchInventory);
  }


  // /orderId":"639025fb304f125c024c5159",
  // "Reason":"price issue"
  //https://convergeuatapi.futuremankind.com/api/marketplace/cancel-order/6391a162410443fd589b9580
  public CanceleleteOrder(orderId: string, Reason: string, Remarks: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/cancel-order`;
    return this.http.put(url, { orderId, Reason, Remarks });
  }
  uploadHealthRecord(files: any, image: any, healthRecord: any, orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/upload-document`;
    const formData: FormData = new FormData();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      if (!fileName.endsWith('jpg') && !fileName.endsWith('png') && !fileName.endsWith('jpeg') && !fileName.endsWith('gif')) {
        formData.append('files', files[i], files[i].name);
      } else {
        formData.append('fileName', fileName);
      }
    }
    formData.append('document', image);
    formData.append('healthRecord', JSON.stringify(healthRecord));
    formData.append('healthRecordType', healthRecord.type);
    formData.append('orderId', orderId);
    return this.http.post(url, formData);
  }

  uploadConsumerHealthRecord(files: any, image: any, healthRecord: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/upload-consumer-document`;
    const formData: FormData = new FormData();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      // if (!fileName.endsWith('jpg') && !fileName.endsWith('png') && !fileName.endsWith('jpeg') && !fileName.endsWith('gif')) {
      //   formData.append('files', files[i], files[i].name);
      // } else {
      //   formData.append('fileName', fileName);
      // }
      formData.append('files', files[i], files[i].name);
    }
    formData.append('document', image);
    formData.append('healthRecord', JSON.stringify(healthRecord));
    return this.http.post(url, formData);
  }

  getHealthRecordDocument(healthRecordDocumentId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/health-record-document/${healthRecordDocumentId}`;
    return this.http.get(url);
  }
  getUserDocument(fileId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/specific-document/${fileId}`;
    return this.http.get(url);
  }
  savePrescriptionData(prescription: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/health-record-document`;
    return this.http.post(url, prescription);
  }
  getEligibleMembershipBenefits(contactId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/eligible-membership-benefits/${contactId}`;
    return this.http.get(url);
  }

  availBenefit(benefitAvailment: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/avail-membership-benefit`;
    return this.http.post(url, benefitAvailment);
  }
  getBenefitUsage(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/membership-benefit-usage/${orderId}`;
    return this.http.get(url);
  }
  removeBenefitUsage(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/membership-benefit-usage/${orderId}`;
    return this.http.delete(url);
  }

  getOrders(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/orders`;
    return this.http.post(url, criteria);
  }
  getStockistOrderHistory(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/get-stockist-orders-by-city-state-date-range`;
    return this.http.post(url, criteria);
  }
  getOrdersForDownloadPdf(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/orders-history`;
    return this.http.post(url, criteria);
  }

  getDoctorWiseOrdersForDownloadPdf(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/orders-history-By-Doctor`;
    return this.http.post(url, criteria);
  }
  //https://convergeuatapi.futuremankind.com/api/marketplace/orders-history

  dispatchPickUp(orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/dispatch-pick-up-order/${orderId}`;
    return this.http.post(url, {});
  }
  public savePackageInfo(dispatchInfo: any, orderId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/package-order/${orderId}`;
    return this.http.post(url, dispatchInfo);
  }
  mergeOrders(mergeableOrders: Array<any>): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/merge-orders`;
    return this.http.post(url, mergeableOrders);
  }
  getAllStores(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/stores`;
    return this.http.get(url);
  }
  modifyStoreLocationInOrders(obj: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/modify-store-location-in-orders`;
    return this.http.post(url, obj);
  }
  getCartTotal(): number {
    let total = 0;
    for (const item of this.cart) {
      total += item.quantity * item.netRate;
    }
    return total;
  }
  getCustomerOrderHistory(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/order-history/${id}`;
    return this.http.get(url);
  }
  getMonthlyPurchaseHistory(contactId: string): Observable<any> {
    const url = `${this.apiOrigin}/api/marketplace/transplant-purchase-monthly-summary/${contactId}`;

    return this.http.get(url);
  }

  updateMonthlyPurchaseHistory(customerId: string): Observable<any> {
    const url = `${this.apiOrigin}/api/customer-service/update-transplant-customer-purchase-history/${customerId}`;

    return this.http.get(url);
  }

  updateMonthlyOrderHistory(customerId: string): Observable<any> {
    const url = `${this.apiOrigin}/api/customer-service/update-transplant-customer-order-history/${customerId}`;

    return this.http.get(url);
  }

  updateMembershipTier(contactId: string): Observable<any> {
    const url = `${this.apiOrigin}/api/customer-service/update-transplant-membership-tier/${contactId}`;

    return this.http.get(url);
  }
  getDiagnosticLabs(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/diagnostic-labs`;
    return this.http.get(url);
  }
  getDrugLevelRequest(requestId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/drug-level-request/${requestId}`;
    return this.http.get(url);
  }
  getPathKindNearestLab(requestPincode: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/get-nearest-pathkind-labs?pincode=${requestPincode}`;
    return this.http.get(url);
  }
  saveDrugLevelTest(value: any, contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/save-drug-level-test/${contactId}`;
    return this.http.post(url, value);
  }
  deleteDrugLevelMarkerRequests(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/patient-drug-level-marker-request/${id}`;
    return this.http.delete(url);
  }



  cancelDrugLevelMarkerRequests(id: any, reason): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/cancel-drug-level-market-request/${id}/${reason}`;
    return this.http.put(url, {});
  }
  getDrugLevelRequestForDay(year: string, month: string, day: string, getPendingOnly: boolean): Observable<any> {
    const criteria: any = {};
    criteria.day = parseInt(day, 10);
    criteria.month = parseInt(month, 10);
    criteria.year = parseInt(year, 10);
    criteria.status = getPendingOnly ? 'Pending' : 'All';
    const url = `${environment.apiOrigin}/api/marketplace/drug-level-requests-for-day`;
    return this.http.post(url, criteria);
  }
  getPastDrugLevelMarkerRequests(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/patient-drug-level-marker-request/${id}`;
    return this.http.get(url);
  }
  getDiagnosticTests(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/diagnostic-tests`;
    return this.http.get(url);
  }
  getCityName(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/get-city`;
    return this.http.get(url);
  }
  getProductNames(tag: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/product-names/${tag}`;
    return this.http.get(url);
  }
  uploadStockiestOrder(files: any, image: any, order: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/upload-stockiest-order`;
    const formData: FormData = new FormData();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      // if (!fileName.endsWith('jpg') && !fileName.endsWith('png') && !fileName.endsWith('jpeg') && !fileName.endsWith('gif')) {
      //   formData.append('files', files[i], files[i].name);
      // } else {
      //   formData.append('fileName', fileName);
      // }
      formData.append('files', files[i], files[i].name);
    }
    formData.append('document', image);
    formData.append('order', JSON.stringify(order));
    return this.http.post(url, formData);
  }
  getSpecificCartTotal(cart: any): number {
    let total = 0;
    for (const item of cart) {
      total += item.quantity * item.netRate;
    }
    return total;
  }
  searchProducts(searchText: string, storeCode: string = null): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-products`;
    const criteria: any = {};
    criteria.searchText = searchText;
    return this.http.post(url, criteria);
  }
  getCustomerPendingOrders(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/customer-pending-orders/${id}`;
    return this.http.get(url);
  }
  saveOrder(order: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/order`;
    return this.http.put(url, order);
  }
  getStoreLocations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/store-locations`;
    return this.http.get(url);
  }
  allocatePendingOrders(allocation: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/allocate-pending-orders`;
    return this.http.post(url, allocation);
  }
  getSalesTeam(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/sales-team`;
    return this.http.get(url);
  }
  getUnusedCouponCode(labName: string, paymentTerms: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/unused-coupon-codes`;
    const criteria: any = {};
    criteria.labName = labName;
    criteria.paymentTerms = paymentTerms;
    return this.http.post(url, criteria);
  }
  scheduleDrugLevelTest(value: any, id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/schedule-drug-level-test/${id}`;
    return this.http.post(url, value);
  }
  getDoctorList(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-list/`;
    return this.http.get(url);
  }
  mapTransplantDoctor(contactId: any, selectedDoctorId: string, activeFileId: string, therapy: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/map-transplant-doctor/${contactId}/${selectedDoctorId}/${activeFileId}/${therapy}`;
    return this.http.post(url, {});
  }
  getFilteredHospitalList(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/filtered-hospital-list`;
    return this.http.post(url, value);
  }

  getTopCustomersByRewardPointsAndRecency(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/top-customer-list-by-reward-points-and-recency`;
    return this.http.post(url, value);
  }

  saveCartInOrder(order: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/cart-in-order`;
    return this.http.post(url, order);
  }

  getUniqueChannels(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/unique-channels`;
    return this.http.get(url);
  }

  getUniqueStoreLocations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/unique-store-locations`;
    return this.http.get(url);
  }

  getUniqueProducts(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/unique-products`;
    return this.http.get(url);
  }

  getSalesBreakUp(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/sales-break-up`;
    return this.http.post(url, value);
  }

  saveStore(value: any, sellerId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/store/${sellerId}`;
    return this.http.post(url, value);
  }

  saveDiagnosticTest(form: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/diagnostic-tests`;
    return this.http.post(url, form);
  }
  getDiagnosticTest(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/diagnostic-test/${id}`;
    return this.http.get(url);
  }
  saveDiagnosticLab(diagnosticLab: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/diagnostic-labs`;
    return this.http.post(url, diagnosticLab);
  }

  saveThirdPartyCoupons(labName: string, value: any): Observable<any> {
    value.labName = labName;
    const url = `${environment.apiOrigin}/api/marketplace/third-party-coupons`;
    return this.http.post(url, value);
  }

  getSalesByMonth(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/total-sales-by-month`;
    return this.http.get(url);
  }
  GetProducts(body): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-products-in-store`;
    // const url = `${environment.apiOrigin}/api/marketplace/search-products`;
    return this.http.post(url, body);
  }
  GetInventoryList(body): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-products-in-store-plantcodeskucode`;
    return this.http.post(url, body);
  }
  AddBatchWiseInventory(body): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/UpdateInventory`;
    return this.http.post(url, body);
  }
  GetStores(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/stores`;
    return this.http.get(url);
  }
  GetAvailableCouopns(labName: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/unused-coupon-codes-number?LabName=${labName}`;
    return this.http.get(url);
  }


  getTestsConducted(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/tests-conducted`;
    return this.http.post(url, criteria);
  }

  getLocationOrders(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/location-open-orders`;
    return this.http.get(url);
  }

  getTodaysOrderCountByChannel(filterCriteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/order-count-by-channel-today`;
    return this.http.post(url, filterCriteria);
  }

  getTodaysPatientCount(filterCriteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/patient-count-today`;
    return this.http.post(url, filterCriteria);
  }

  getMembershipBenefitsUsage(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/membership-benefits-usage`;
    return this.http.post(url, criteria);
  }

  getCouponsByLabName(labName) {
    const url = `${environment.apiOrigin}/api/marketplace/unused-coupon-codes?LabName=${labName}`;
    return this.http.get<any>(url);
  }
}
